import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    changePassword:{},
    //notification
    getNotification:{},
    postNotification:{},
    notificationStatus:"idle",
    notificationError:'',

    //security question
    getSecurityQuestion:{},
    postSecurityQuestion:{},
    securityQuestionStatus:"idle",
    securityQuestionError:'',

    //social profile
    getSocialProfie:{},
    postSocialProfile:{},
    socialProfileStatus:"idle",
    socialProfileError:'',

    //general Info
    postGeneralData:{},

    //personal Info
    postPersonalData:{},
    setProfileImageData:{},
    personalInfoStatus: "idle",

    //delete account
    deleteAccountDetail:{},

    //delete Profile Pic
    deleteProfileData:{},

    // 2FA
    twoFactorAuthStatus: "idle",
}

export const changePasswordApi = createAsyncThunk('setting/changePassword',async (initalData) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    formData.append("new_password",initalData.new_password);
    formData.append("old_password",initalData.old_password);
    let response = await axios.post('Register/updatePassword',formData);
    if (response.status === 200) {
        if(response.data.error!==2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }

})

export const fetchNotification = createAsyncThunk('setting/fetchNotification', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('Form/getAllNotification',formData);
    if (response.status === 200) {
        if(response.data.error!==2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

export const postNotificationData = createAsyncThunk('setting/postNotificationData', async (initalData) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    formData.append("selected_items",JSON.stringify(initalData.selected_items));
    formData.append("sms",initalData.sms);
    formData.append("email",initalData.email);
    let response = await axios.post('Form/updateNotificationItem',formData);
    if (response.status === 200) {
        if(response.data.error!==2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})
export const fetchSecurityQuestion = createAsyncThunk('setting/fetchSecurityQuestion', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('Form/getSecurityQuestion',formData);
    if (response.status === 200) {
        if(response.data.error!==2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

export const postSecurityQuestionData = createAsyncThunk('setting/postSecurityQuestionData', async (initalData) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    formData.append("security_question",initalData.security_question);
    formData.append("security_answer",initalData.security_answer);
    let response = await axios.post('Form/updateSecurityQuestion',formData);
    if (response.status === 200) {
        if(response.data.error!==2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

export const fetchSocialProfile = createAsyncThunk('setting/fetchSocialProfile', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('Form/getSocialLinks',formData);
    if (response.status === 200) {
        if(response.data.error!==2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

export const postSoclalProfile = createAsyncThunk('setting/postSoclalProfile', async (initalData) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    formData.append("twitter_link",initalData.twitter_link);
    formData.append("facebook_link",initalData.facebook_link);
    let response = await axios.post('Form/updateSocialLinks',formData);
    if (response.status === 200) {
        if(response.data.error!==2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

export const postGeneralInfo = createAsyncThunk('setting/postGeneralInfo', async (initalData) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    formData.append("full_name",initalData.full_name);
    formData.append("title",initalData.title);
    formData.append("address",initalData.address);
    formData.append("address2",initalData.address2);
    formData.append("country",initalData.country);
    formData.append("state",initalData.state);
    formData.append("zip",initalData.zip);
    formData.append("phone_num",initalData.phone_nu);
    let response = await axios.post('Form/updateProfileSettingGeneral',formData);
    if (response.status === 200) {
        if(response.data.error!==2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

export const postPersonalInfo = createAsyncThunk('setting/postPersonalInfo', async (initalData) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    formData.append("marital_status",initalData.marital_status);
    formData.append("kids",initalData.kids);
    formData.append("about_me",initalData.about_me);
    formData.append("job",initalData.job);
    formData.append("income",initalData.income);
    formData.append("dob",initalData.dob);
    formData.append("profile_img",initalData.profile_img);
    let response = await axios.post('Form/updateProfileSettingPersonalInfo',formData);
    if (response.status === 200) {
        if(response.data.error!==2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

export const deleteProfilePic = createAsyncThunk('setting/deleteProfilePic', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('Form/removeProfilePic',formData);
    if (response.status === 200) {
        if(response.data.error!==2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

export const deleteAccount = createAsyncThunk('setting/deleteAccount', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('register/deleteUser',formData);
    if (response.status === 200) {
        if(response.data.error!==2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

export const setTwoFactorAuth = createAsyncThunk('setting/setTwoFactorAuth',async (status) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    formData.append("enable_2FA",status);
    
    let response = await axios.post('form/setTwoFactorAuthentication',formData);
    if (response.status === 200) {
        if(response.data.error!==2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

export const setProfilePicture = createAsyncThunk('setting/setProfilePicture',async (fileData) => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    formData.append("profile_img",fileData);
    
    let response = await axios.post('form/updateUserProfileImage',formData);
    if (response.status === 200) {
        if(response.data.error!==2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

const removeLocalStorage = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("company_id");
    localStorage.removeItem("company_logo");
    localStorage.removeItem("accessToken");
}

const SettingSlice = createSlice({
    name:'setting',
    initialState,
    reducers:{
        blankPassword:(state)=>{
            state.changePassword = {};
        },
        blankNotification:(state) => {
            state.getNotification = {};
            state.notificationStatus = "idle";
            state.notificationError = '';
            state.postNotification = {};
        },
        blankSecurityQuestion:(state) => {
            state.getNotification = {};
            state.notificationStatus = "idle";
            state.notificationError = '';
            state.postNotification = {};
        },
        blankSocialProfile:(state) => {
            state.getSocialProfie = {};
            state.socialProfileStatus = "idle";
            state.socialProfileError = '';
            state.postSocialProfile = {};
        },
        blankGeneralInfo:(state) => {
            state.postGeneralData = {}
        },
        blankPersonalInfo:(state) => {
            state.postPersonalData = {}
        },
        blankTwoFactorAuth: (state) => {
            state.twoFactorAuthStatus = "idle"
        },
        blankDeleteProfileData: (state) => {
            state.deleteProfileData = {}
        },

        
    },
    extraReducers:(builder) => {
        builder.addCase(changePasswordApi.fulfilled,(state,action)=>{
            state.changePassword = action.payload
        })
        builder.addCase(fetchNotification.pending, (state)=>{
            state.notificationStatus = 'loading';
        })  
        builder.addCase(fetchNotification.fulfilled,(state,action)=>{
            state.notificationStatus = 'succeeded';
            state.getNotification = action.payload;
            state.notificationError = '';
        })
        builder.addCase(fetchNotification.rejected,(state,action)=>{
            state.notificationStatus = 'failed';
            state.getNotification = {};
            state.notificationError = action.error.message;
        })
        builder.addCase(postNotificationData.fulfilled,(state,action)=>{
            state.postNotification = action.payload
        })

        //security question
        builder.addCase(fetchSecurityQuestion.pending, (state)=>{
            state.securityQuestionStatus = 'loading';
        })  
        builder.addCase(fetchSecurityQuestion.fulfilled,(state,action)=>{
            state.securityQuestionStatus = 'succeeded';
            state.getSecurityQuestion = action.payload;
            state.securityQuestionError = '';
        })
        builder.addCase(fetchSecurityQuestion.rejected,(state,action)=>{
            state.securityQuestionStatus = 'failed';
            state.getSecurityQuestion = {};
            state.securityQuestionError = action.error.message;
        })
        builder.addCase(postSecurityQuestionData.fulfilled,(state,action)=>{
            state.postSecurityQuestion = action.payload
        })

        //social Profile
        builder.addCase(fetchSocialProfile.pending, (state)=>{
            state.socialProfileStatus = 'loading';
        })  
        builder.addCase(fetchSocialProfile.fulfilled,(state,action)=>{
            state.socialProfileStatus = 'succeeded';
            state.getSocialProfie = action.payload;
            state.socialProfileError = '';
        })
        builder.addCase(fetchSocialProfile.rejected,(state,action)=>{
            state.socialProfileStatus = 'failed';
            state.getSocialProfie = {};
            state.socialProfileError = action.error.message;
        })
        builder.addCase(postSoclalProfile.fulfilled,(state,action)=>{
            state.postSocialProfile = action.payload
        })

        //general Info
        builder.addCase(postGeneralInfo.fulfilled,(state,action)=>{
            state.postGeneralData = action.payload
        })

        //Personal Info
        builder.addCase(postPersonalInfo.fulfilled,(state,action)=>{
            state.postPersonalData = action.payload
        })
        builder.addCase(setProfilePicture.pending,(state,action)=>{
            state.personalInfoStatus = "loading"
        })
        builder.addCase(setProfilePicture.fulfilled,(state,action)=>{
            state.setProfileImageData = action.payload;
            state.personalInfoStatus = "succeeded"
        })
        

        //delete account
        builder.addCase(deleteAccount.fulfilled,(state,action)=>{
            state.deleteAccountDetail = action.payload
        })

        //delete profile Pic
        builder.addCase(deleteProfilePic.fulfilled,(state,action)=>{
            state.deleteProfileData = action.payload
        })


        // 2FA
        builder.addCase(setTwoFactorAuth.fulfilled,(state,action)=>{
            state.twoFactorAuthStatus = "succeeded"
        })

    }
});

export const {blankPassword,
              blankNotification,
              blankSecurityQuestion,
              blankSocialProfile,
              blankGeneralInfo,
              blankPersonalInfo, blankTwoFactorAuth, blankDeleteProfileData} = SettingSlice.actions;

export default SettingSlice.reducer;